var blockquote_default = {
  "fontElementMap": "_2KjTv",
  "quote": "Oy8zr"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
